const Pcdesk = () => {

    return (
    <section data-aos="flip-left" className="max-16 main-pcdesk flex flex-col md:flex-row items-center gap-8 px-12 py-20 bg-white">
      {/* Text Left */}
      <div className="text-left">
        <h2 className="text-4xl mb-4 text-schoolRed text-bold">Principal’s desk</h2>
        <h3 className="text-2xl mb-4 text-schoolBlue text-bold text-lato">Welcome to Springdales The School!</h3>
        <p className="text-gray-700 leading-relaxed text-lato">
            At Springdales The School, we believe in fostering a nurturing and inclusive environment where every student can thrive. Our dedicated faculty and staff are committed to providing a high-quality education that inspires curiosity, creativity, and a love for learning.
            <br/><br/>
            We are proud of our diverse community, where students from all backgrounds come together to grow academically and personally. Whether you are a prospective student, a current family, or a member of our community, we invite you to explore our website and discover what makes <b>Springdales The School</b> a special place for education.
            <br/><br/>
            Join us in our journey of excellence, where we empower our students to achieve their full potential and become responsible, engaged citizens. Welcome to our community!
            <br/><br/>
            Sincerely,<br/>
            Mrs. J Eashad Begum,<br/>
            Springdales The School.
        </p>
      </div>

      {/* Image Right */}
      <div className="md:w-1/2 flex justify-end">
        <img
          src="https://res.cloudinary.com/dkmxvgmxd/image/upload/v1755621356/principal_sqlxix.jpg"
          alt="School"
          className="w-full max-w-sm rounded-lg shadow-md" loading="lazy"
        />
      </div>
    </section>
    );

};

export default Pcdesk;